export const CAMERA_MODE = {
  user: "user",
  environment: "environment",
};

export const RECORDING_STATUS = {
  idle: "idle",
  recording: "recording",
  stopped: "stopped",
}

export const RECORDING_MODE = {
  audio: "audio",
  video: "video",
  photo: "photo",
}

export const RECORDING_LIMITS = {
  video: 25
}

export const TIMERS_GAME = {
  timeInRanking: 15,
  timeQualification: 15,
  timeToReviewQuestions: 4,
}

export const ANIMATIONS = {
  idle: 1,
  hello: 2,
  talking: 3,
  reading: 4,
  celebrating: 5
};

export const SUBTITLE_RESTRICTION = "ESCNNA";

export const GameStates = {
  STANDBY: "standBy",
  WELCOME: "welcome",
  SPINNER: "spinner",
  JOKER: "joker",
  IN_ROUND: "in_round",
  QUALIFICATION: "qualification",
  RANKING: "ranking",
  GRADING: "grading",
  FINAL_RANKING: "final_ranking",
  FINISHED: "finished"
};